var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFunction = function SvgIconFunction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.003 2.75h-.002a4.01 4.01 0 0 0-3.935 3.285v.002l-.9 4.963H6.75a1 1 0 1 0 0 2h4.052l-.836 4.604a2.01 2.01 0 0 1-1.97 1.646H5.25a1 1 0 1 0 0 2H8a4.01 4.01 0 0 0 3.934-3.285v-.002l.9-4.963h4.416a1 1 0 1 0 0-2h-4.052l.835-4.604a2.01 2.01 0 0 1 1.971-1.646h2.746a1 1 0 1 0 0-2z"
  })));
};
export default SvgIconFunction;